/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { Tag, Tooltip, message } from 'antd'
import moment from 'moment'
import { routesConfig } from '../routers/constants'
import {
  ASSIGNEE_SHORT_NAME_LENGTH, configurationKeyMapper, parameterKeyMapper,
  PATIENT_SHORT_NAME_LENGTH,
  SECONDS_IN_A_MINUTE, SECONDS_IN_AN_HOUR, SECONDS_IN_A_DAY,
  LOCAL_STORAGE_PROVIDERS_LIST_KEY,
  LOCAL_STORAGE_HUB_DEVICES_LIST_KEY,
  LOCAL_STATUS_URL_SEGMENT, defaultStudiesDateSelect,
} from '../config/constants'
import { bodyPart } from '../config/body-part'
import { modality } from '../config/modality'
import { EVENTS } from '../config/segment-events'
import { ASSIGNMENT_CASCADE_KEYS, ASSIGNMENT_CASCADE_OPTIONS } from '../config/studies'
import { attachedReportDocumentTypes, relatedDocumentTypes } from '../config/azure-storage-documents'
import history from '../routers/history'
import {find, forEach, get, groupBy, has, isArray, isObject, isString, join, map, merge, reverse, some, sortBy, store } from 'lodash'
import { ReactComponent as PlusSquareIcon } from '../static/plusSquareIcon.svg';
import { ReactComponent as MinusSquareIcon } from '../static/minusSquareIcon.svg';

export const setFieldOptions = (choices, resetOption = null, addPrefixToLabel) => {
  let modifiedChoices = {}
  if (resetOption) {
    const { label, value } = resetOption
    modifiedChoices[value] = label
    merge(modifiedChoices, choices)
  } else {
    modifiedChoices = choices
  }
  const optionIsAString = modifiedChoices && modifiedChoices[1] && isObject(modifiedChoices[1])
  return map(modifiedChoices, (choice, key) => {
    return optionIsAString ? ({ label: choice, value: key }) : ((addPrefixToLabel) ? { label: choice.value + ' - ' + choice.label, value: choice.value } : choice)
  })
}


export const getCalendarTime = (timeProvided) => {
  const timeLocally = moment.utc(moment(timeProvided).toDate()).local()
  const displayTime = timeLocally.calendar(null, {
    sameDay: '[Today at ] hh:mm a',
    nextDay: '[Tomorrow at] hh:mm a',
    nextWeek: 'dddd [at] hh:mm a',
    lastDay: '[Yesterday at] hh:mm a',
    lastWeek: '[Last] dddd [at] hh:mm a',
    sameElse: 'DD/MM/YYYY [at] hh:mm a'
  })
  return displayTime
}

export const getTimeFromNow = (timeProvided) => {
  const timeLocally = moment.utc(moment(timeProvided).toDate()).local()
  return moment(timeLocally).fromNow()
}

export const replaceCaretFromString = (inputString) => {
  if (inputString && inputString.length > 1) {
    return inputString.split('^').join(' ')
  }
  return inputString
}

export const transformPatientName = (patientName) => {
  if (patientName && patientName.length) {
    patientName = patientName.split('^').join(' ')
  }
  return patientName
}

export const renderHTML = (value) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: value }} />
  )
}

export const goToPage = (studyGuid) => {
  history.push(`${routesConfig.STUDY_LIST}/view/${studyGuid}`)
}

export const selectFieldFilterHandler = (input, option) => {
  return isString(option.props.children) && (option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0)
}

export const generateQueryString = (payload) => {
  let queryStringSegments = []
  let offset
  let offsetToPass
  if (payload.sorting) {
    const orderSorting = !payload.order ? `-${payload.sorting}` : `${payload.order === 'ascend' ? '' : '-'}${payload.sorting}`
    queryStringSegments.push(parameterKeyMapper['sorting'] + '=' + orderSorting)
  } else {
    if (payload.order) {
      const orderSorting = `${payload.order === 'ascend' ? '' : '-'}${defaultStudiesDateSelect}`
      queryStringSegments.push(parameterKeyMapper['sorting'] + '=' + orderSorting)
    }
  }
  forEach(payload, (item, key) => {
    if (item && key !== 'payload' && key !== 'sorting' && key !== 'order') {
      if (isArray(item)) {
        queryStringSegments.push(parameterKeyMapper[key] + '=' + join(item, ','))
      } else if (key === 'offset') {
        offset = parseInt(item, 10)
        offsetToPass = offset === 0 ? offset : (offset - 1) * payload.limit
        queryStringSegments.push(parameterKeyMapper[key] + '=' + offsetToPass)
      } else if (key === 'createdAt') {
      //   queryStringSegments.push(parameterKeyMapper[key] + '=' + '+created_at')
      } else {
        queryStringSegments.push(parameterKeyMapper[key] + '=' + item)
      }
    }
  })
  return join(queryStringSegments, '&')
}

export const getFilterDropdownOptions = (configurationKey, aggregations) => {
  let configurationKeysToFetch = has(configurationKeyMapper, configurationKey) && configurationKeyMapper[configurationKey]
  let options = {}
  let configurationContent
  let statusArray
  if (isArray(configurationKeysToFetch)) {
    forEach(configurationKeysToFetch, (keyToFetch) => {
      if (keyToFetch === 'modality') {
        configurationContent = modality
        Object.assign(options, configurationContent)
      } else if (keyToFetch === 'body_part') {
        configurationContent = bodyPart
        Object.assign(options, configurationContent)
      } else if (keyToFetch === 'facility_name') {
        configurationContent = aggregations && aggregations['source_facilities']
        Object.assign(options, configurationContent)
      }
       else if (keyToFetch === 'status') {
        configurationContent = aggregations && aggregations['source_facilities']
        Object.assign(options, configurationContent)
      }
    })
  } else {
    if (configurationKeysToFetch === 'modality') {
      configurationContent = modality
    } else if (configurationKeysToFetch === 'body_part') {
      configurationContent = aggregations && aggregations['body_parts']
    } else if (configurationKeysToFetch === 'facility_name') {
      configurationContent = aggregations && aggregations['source_facilities']
    }
    else if (configurationKeysToFetch === 'status') {
      configurationContent = aggregations && aggregations['status']
      }
    Object.assign(options, configurationContent)
  }
  const optionIsAString = options && options[0] && isObject(options[0])
  return map(options, (choice, key) => {
    return optionIsAString ? ({ label: choice, value: key }) : choice
  })
}

export const renderPatientNameShort = (text) => {
  const nameLength = text && text.length
  const patientTransformedName = (text) ? transformPatientName(text) : ''
  if (nameLength > PATIENT_SHORT_NAME_LENGTH) {
    return (
      <div>
        <Tooltip title={patientTransformedName}>
          <div className='patient_name_table_fields'>{patientTransformedName}</div>
        </Tooltip>
      </div>
    )
  }
   else {
    return (<div>{patientTransformedName}</div>)
  }
}

export const renderFileTypeDisplayText = (text) => (relatedDocumentTypes[text] && relatedDocumentTypes[text].label)

export const renderReportTypeDisplayText = (text) => (attachedReportDocumentTypes[text] && attachedReportDocumentTypes[text].label)

export const renderPatientNameWithSuffix = (text, record) => {
  const { patient_age: patientAge, patient_gender: patientGender, patient_name: patientName } = record
  let patientNameSuffix = ''
  if (patientAge && patientAge !== 'None' && patientGender) {
    patientNameSuffix = patientAge + '/' + patientGender
  } else if (patientAge && patientAge !== 'None') {
    patientNameSuffix = patientAge
  } else if (patientGender) {
    patientNameSuffix = patientGender
  }
  const patientNameSuffixText = patientNameSuffix !== '' && ('(' + patientNameSuffix + ')')
  const patientTransformedName = (patientName) ? transformPatientName(patientName) : ''
  const nameLength = patientTransformedName && patientTransformedName.length
  if (nameLength > PATIENT_SHORT_NAME_LENGTH) {
    const patientShortenName = patientTransformedName.substr(0, PATIENT_SHORT_NAME_LENGTH)
    const shortNameSuffix = (patientTransformedName.length !== patientShortenName.length) ? '...' : ''
    return (
      <>
        <Tooltip title={patientTransformedName}>
          <div>{patientShortenName + shortNameSuffix} {patientNameSuffixText}</div>
        </Tooltip>
      </>
    )
  } else {
    return (<>{patientTransformedName} {patientNameSuffixText}</>)
  }
}

export const renderAssigneeNamePrefix = (assigneeType) => {
  switch (assigneeType) {
    case 'provider':
      return 'Organization: '
    case 'facility':
      return 'Facility: '
    case 'independent radiologist':
    case 'radiologist':
    default:
      return 'Rad: '
  }
}



export const renderServiceProviderShortName = (fullName) => {
  const nameLength = fullName?.length
  if (nameLength > ASSIGNEE_SHORT_NAME_LENGTH) {
    const shortName = fullName.substr(0, ASSIGNEE_SHORT_NAME_LENGTH)
    const shortNameSuffix = (shortName?.length !== fullName?.length) ? '...' : ''
    return shortName + shortNameSuffix
  } else {
    return fullName
  }
}

export const createLoadingSelector = (actions) => (state) => {
  return some(actions, (action) => get(state, ('isLoading.' + action)))
}

export const getSLATimerString = (timeInSeconds) => {
  var seconds = timeInSeconds % SECONDS_IN_A_MINUTE
  var minutes = Math.floor(((timeInSeconds % SECONDS_IN_AN_HOUR) - seconds) / SECONDS_IN_A_MINUTE)
  var hours = Math.floor(((timeInSeconds % SECONDS_IN_A_DAY) - minutes) / SECONDS_IN_AN_HOUR)
  var days = Math.floor(timeInSeconds / SECONDS_IN_A_DAY)
  var secondsPrefix = (seconds < 10) ? '0' : ''
  var minutesPrefix = (minutes < 10) ? '0' : ''
  var hoursPrefix = (hours < 10) ? '0' : ''
  var daySegment = (days > 0) ? days + 'd ' : ''
  return daySegment + hoursPrefix + hours + 'h ' + minutesPrefix + minutes + 'm ' + secondsPrefix + seconds + 's'
}

export const getProviderListFromLocalStorage = () => {
  const providerListFromLocalStorage = store.get(LOCAL_STORAGE_PROVIDERS_LIST_KEY)
  return providerListFromLocalStorage && providerListFromLocalStorage
}

export function isHTML(str) {
  var a = document.createElement('div');
  a.innerHTML = str;

  for (var c = a.childNodes, i = c.length; i--; ) {
    if (c[i].nodeType == 1) return true; 
  }

  return false;
}

export function getReportType(html) {
  const div = document.createElement("div");
  div.innerHTML = html;
  const reportType = div.querySelector("#report-type");
  return reportType?.title
}

export const prepareSourceFacilityOptions = (externalSourceFacilities, internalSourceFacilities, studyFormData, isPhysician) => {
  let optionsArray = []

  const { physicianModal } = studyFormData || {};
  const jsonItems = studyFormData && studyFormData.dicomFiles && studyFormData.dicomFiles.jsonContent && studyFormData.dicomFiles.jsonContent

  let facilitiesFromDICOM = []
  let newFacilities = []
  let listOfFacilityNames = []
  let internalOptions = { key: 'aaa', value: isPhysician ? "internal-physician-guid" : "internal-facility-guid", label: isPhysician ? "My Physicians" : "My Facilities", children: [] }
  if (internalSourceFacilities && internalSourceFacilities.length > 0) {
    forEach(internalSourceFacilities, ({ full_name, name, guid }, key) => {
      listOfFacilityNames.push(isPhysician ? full_name : name)
      internalOptions.children.push({ key, label: isPhysician ? full_name : name, value: guid })
    })
    optionsArray.push(internalOptions)
  }
  let externalOptions = { key: 'bbb', value: isPhysician ? "external-physician-guid" : "external-facility-guid", label: isPhysician ? "Other Physicians" : "Other Facilities", children: [] }
  if (externalSourceFacilities && externalSourceFacilities.length > 0) {
    forEach(externalSourceFacilities, ({ full_name, name, guid }, key) => {
      listOfFacilityNames.push(isPhysician ? full_name : name)
      externalOptions.children.push({ key, label: isPhysician ? full_name : name, value: guid })
    })
    optionsArray.push(externalOptions)
  }
  if(jsonItems && jsonItems.length > 0 && jsonItems[0].StudyDetails){
  forEach(jsonItems, ({ StudyDetails: { InstitutionName }, MyPhysician, OtherPhysician, NewFacility, OtherFacility, MyFacility }) => {
    if (InstitutionName && InstitutionName !== undefined && !listOfFacilityNames.includes(InstitutionName)) {
      listOfFacilityNames.push(InstitutionName)
      facilitiesFromDICOM.push(InstitutionName)
    }
    if (NewFacility && NewFacility !== '' && !listOfFacilityNames.includes(NewFacility)) {
      listOfFacilityNames.push(NewFacility)
      newFacilities.push(NewFacility)
    }
    if (!isPhysician && externalSourceFacilities?.length && OtherFacility && OtherFacility !== '' && !listOfFacilityNames.includes(listOfFacilityNames)) {
      listOfFacilityNames.push(OtherFacility)
      externalOptions.children.push({key: externalSourceFacilities.length, label: OtherFacility, value: OtherFacility})
    }
    if (isPhysician && externalSourceFacilities?.length && OtherPhysician && OtherPhysician !== '' && !listOfFacilityNames.includes(listOfFacilityNames)) {
      listOfFacilityNames.push(OtherPhysician)
      externalOptions.children.push({key: externalSourceFacilities.length, label: OtherPhysician, value: OtherPhysician})
    }
    if (!isPhysician && internalSourceFacilities?.length && MyFacility && MyFacility !== '' && !listOfFacilityNames.includes(listOfFacilityNames)) {
      listOfFacilityNames.push(MyFacility)
      internalOptions.children.push({key: internalSourceFacilities.length, label: MyFacility, value: MyFacility})
    }
    if (isPhysician && internalSourceFacilities?.length && MyPhysician && MyPhysician !== '' && !listOfFacilityNames.includes(listOfFacilityNames)) {
      listOfFacilityNames.push(MyPhysician)
      internalOptions.children.push({key: internalSourceFacilities.length, label: MyPhysician, value: MyPhysician})
    }
  })
  }
  if (physicianModal?.MyPhysician) {
    listOfFacilityNames.push(physicianModal.MyPhysician)
    internalOptions.children.push({key: internalSourceFacilities.length, label: physicianModal.MyPhysician, value: physicianModal.MyPhysician})
  }
  if (physicianModal?.OtherPhysician) {
    listOfFacilityNames.push(physicianModal.OtherPhysician)
    externalOptions.children.push({key: internalSourceFacilities.length, label: physicianModal.OtherPhysician, value: physicianModal.OtherPhysician})
  }
  if (facilitiesFromDICOM && facilitiesFromDICOM.length > 0) {
    let derivedOptions = { key: 'ccc', value: 'facilities-from-dicom', label: isPhysician ? "Referring Physician in DICOM" : "Facilities from DICOM", children: [] }
    forEach(facilitiesFromDICOM, (value, key) => {
      derivedOptions.children.push({ key, label: value, value })
    })
    optionsArray.push(derivedOptions)
  }

  if (newFacilities && newFacilities.length > 0) {
    let derivedOptions = { key: 'ddd', value: 'new-facilities', label: isPhysician ? "New Physicians" : "New Facilities", children: [] }
    forEach(newFacilities, (value, key) => {
      derivedOptions.children.push({ key, label: value, value })
    })
    optionsArray.push(derivedOptions)
  }
  if (isPhysician) {
    optionsArray.push({ key: 'eee', value: 'add-new-physicians', label: "Add New Physician", children: [] });
  } else {
    optionsArray.push({ key: 'eee', value: 'add-new-facilities', label: "Add New Facility", children: [] });
  }
  return optionsArray
}

export const setProviderListInLocalStorage = (providerList) => {
  if (!providerList) return
  store.set(LOCAL_STORAGE_PROVIDERS_LIST_KEY, providerList)
}

export const getHubDeviceListInLocalStorage = () => {
  const hubDevicesListFromLocalStorage = store.get(LOCAL_STORAGE_HUB_DEVICES_LIST_KEY)
  return hubDevicesListFromLocalStorage && hubDevicesListFromLocalStorage
}

export const setHubDeviceListInLocalStorage = (hubDevicesList) => {
  if (!hubDevicesList) return
  store.set(LOCAL_STORAGE_HUB_DEVICES_LIST_KEY, hubDevicesList)
}

export const getServiceProviderContent = (serviceProvider, providerOptions, auth, study) => {
  const { facilities, providers, internal_radiologists: internalRadiologists, external_radiologists: externalRadiologists } = providerOptions
  const { 0: assigneeListParentItem, 1: assigneeListChildItem } = serviceProvider
  const { userBasicInfo: { userRealName, userGuid: currentUserGuid }, userSettings: { userType: currentUserGroup } } = auth.getProfile()
  const assignmentRequestBody = {}
  let assigneeName = ''
  let eventName = ''
  let eventData = {
    user_guid: currentUserGuid,
    user_name: userRealName,
    userGroup: currentUserGroup
  }
  const { MYSELF, FACILITY, INTERNAL_RADIOLOGIST, EXTERNAL_RADIOLOGIST, ORGANIZATION } = ASSIGNMENT_CASCADE_KEYS
  switch (assigneeListParentItem) {
    case FACILITY:
      assignmentRequestBody[ASSIGNMENT_CASCADE_OPTIONS[FACILITY].reference] = assigneeListChildItem
      assigneeName = find(facilities, { guid: assigneeListChildItem }).name
      eventName = EVENTS.STUDY_DETAIL.FORM_SUBMISSION.ASSIGN_STUDY_TO_FACILITY
      eventData.facility_guid = assigneeListChildItem
      break
    case ORGANIZATION:
      assignmentRequestBody[ASSIGNMENT_CASCADE_OPTIONS[ORGANIZATION].reference] = assigneeListChildItem
      assigneeName = find(providers, { guid: assigneeListChildItem }).name
      eventName = EVENTS.STUDY_DETAIL.FORM_SUBMISSION.ASSIGN_STUDY_TO_RADIOLOGY_PROVIDER
      eventData.organization_guid = assigneeListChildItem
      break
    case MYSELF:
      assignmentRequestBody[ASSIGNMENT_CASCADE_OPTIONS[MYSELF].reference] = assigneeListChildItem
      assigneeName = find(internalRadiologists, { guid: assigneeListChildItem }) ? find(internalRadiologists, { guid: assigneeListChildItem }).name : userRealName
      eventName = EVENTS.STUDY_DETAIL.FORM_SUBMISSION.ASSIGN_STUDY_TO_SELF
      eventData.radiologist_id = assigneeListChildItem
      break
    case INTERNAL_RADIOLOGIST:
      assignmentRequestBody[ASSIGNMENT_CASCADE_OPTIONS[INTERNAL_RADIOLOGIST].reference] = assigneeListChildItem
      assigneeName = find(internalRadiologists, { guid: assigneeListChildItem }).name
      eventName = EVENTS.STUDY_DETAIL.FORM_SUBMISSION.ASSIGN_STUDY_TO_STUFF_RADIOLOGIST
      eventData.radiologist_id = assigneeListChildItem
      break
    case EXTERNAL_RADIOLOGIST:
      assignmentRequestBody[ASSIGNMENT_CASCADE_OPTIONS[EXTERNAL_RADIOLOGIST].reference] = assigneeListChildItem
      assigneeName = find(externalRadiologists, { guid: assigneeListChildItem }).name
      eventName = EVENTS.STUDY_DETAIL.FORM_SUBMISSION.ASSIGN_STUDY_TO_INDEPENDENT_RADIOLOGIST
      eventData.independent_radiologist_guid = assigneeListChildItem
      break
    default:
      break
  }
  return { assignmentRequestBody, assigneeName, eventName, eventData, assignmentGuid: ((study && study.assignment && study.assignment.guid) || null) }
}

export const transformReportTemplatesList = (reportTemplates) => {
  return groupBy(map(reportTemplates, ({name, guid, availability}) => ({ label: name, value: guid, availability })), 'availability')
}

export const reportTemplateDropdownOptions = (options, targetType) => {
  let publicOptions = []
  let privateOptions = []
  let facilityOptions = []
  if (options && (targetType === 'TemplateSelectField')) {
    forEach(options, (optionGroup, optionGroupLabel) => {
      forEach(optionGroup, ({ label, value }, key) => {
        switch (optionGroupLabel.toLowerCase()) {
          case 'facility':
            facilityOptions.push({ label, value })
            break
          case 'public':
            publicOptions.push({ label, value })
            break
          case 'private':
            privateOptions.push({ label, value })
            break
          default:
            break
        }
      })
    })
  }
  return { publicOptions, privateOptions, facilityOptions }
}

export const sortTimeLineEntries = (sourceArray) => {
  const ascendingList = sortBy(sourceArray, (entry) => entry.occurred_at)
  return reverse(ascendingList)
}


export const getLocalStatusURL = () => {
  let currentUrl = window.location.href
  const splittedURL = currentUrl && currentUrl.length > 0 && currentUrl.split('/')
  let baseURL = splittedURL[2]
  if (baseURL.indexOf(':') !== -1) {
    baseURL = baseURL.split(':')[0]
  }
  const protocol = splittedURL[0]
  return protocol + '//' + baseURL + LOCAL_STATUS_URL_SEGMENT
}


export const isBase64 = (str) => {
  if (!str || str ==='' || str.trim() ===''){ return false; }
  try {
      return window.btoa(window.atob(str)).toString() === str;
  } catch (err) {
      return false;
  }
}

 export const transformCountries = (rawCountries) => rawCountries.map((c) => ({
    text: c.name,
    value: c.alpha
  }));

export const base64ToBlob = async (base64) => {
  const base64Response = await fetch(base64);
  const blob = await base64Response.blob();
  return blob;
}

export const getBase64 = (file) => new Promise((resolve, reject) =>  {
  var reader = new FileReader();
  reader.readAsDataURL(file[0]);
  reader.onload = () => resolve(reader.result);
  reader.onerror = (error) => reject(error);
});

export const getImageSize = (src) => {
  const image = new Image()
  image.src = src
  return {
    width: image.width,
    height: image.height
  };
}

export const toDataURL = (url, callback) => {
  var xhr = new XMLHttpRequest();
  xhr.onload = function() {
    var reader = new FileReader();
    reader.onloadend = function() {
      callback(reader.result);
    }
    reader.readAsDataURL(xhr.response);
  };
  xhr.open('GET', url);
  xhr.responseType = 'blob';
  xhr.send();
}

export function showError(error) {
  if (error.message) {
    return new Promise(resolve => {
      message.error(error.message, 5);
      setTimeout(() => resolve(true), 5000);
    });
  }
  return null;
}

export function showSuccess(text) {
  return new Promise(resolve => {
    message.success(text, 5);
    setTimeout(() => resolve(true), 5000);
  });
}
export const getModifiedStudyObject = (study) => {


  let reportedAt = study?.assignment?.report_signed_at;
  if (reportedAt) {    
    reportedAt = moment(new Date(reportedAt)).format('yyyy-MM-DD')
  }
  
  let obj = {
    studyGuid: study?.guid,
    procedure: study?.procedure || null,
    modality: study?.modality || "ECG",
    bodyPart: study?.body_part == "EMPTY" ? null : study?.body_part ? study?.body_part : null,
    requestedAt: null,
    facilityCountry: null,
    facilityPhone: null,
    facilityName: null,
    facilityEmail: null,
    facilityLocation: null,
    reportedAt: reportedAt || null,
    patientName: study?.patient_name,
    patientGender: study?.patient_gender,
    patientId: study?.patient_id,
    patientDob: study?.patient_date_of_birth,
    accessionNumber:  study?.accession_number || null,
    referringPhysicianName: study?.referring_physician_name || null,
    actionableFindings: null,
    findings: null,
    impression: null,
    clinicalInformation: null,
    comparison: null,
    technique: null,
    reportedByText: "",
    sourceFacilityLogoUrl: null,
    reporterName: null,
    reportingFacilityLogoUrl: null,
    signatureUrl: "",
    signatureHash: null,
  };
  return obj
}


export const timeStamp = text => moment.unix(text);

export const PatientIdHandle = text => {
  if(text) {
    return text
  }
  return "_"
}


export const patientNameHandle = (text, record, setCurrentPatient, currentPatient) => {
  if(currentPatient === record.patient_id){
    return <span onClick={()=> setCurrentPatient(null)} style={{ display: "flex", alignItems: "center", cursor: "pointer" }}> {record?.appointments?.length > 1 ? <MinusSquareIcon style={{ marginRight: "5px" }} /> : <span style={{ marginRight: "23px" }} />  } { text || (record?.first_name + " " + record?.last_name)}</span> 
  } else {
    return <span onClick={()=> setCurrentPatient(record.patient_id)} style={{ display: "flex", alignItems: "center", cursor: "pointer" }}> {record?.appointments?.length > 1 ? <PlusSquareIcon style={{ marginRight: "5px" }} /> : <span style={{ marginRight: "23px" }} />  } { text ||  (record?.first_name + " " + record?.last_name)}</span> 
    }
}

export const appointmentIdHandle= (text, record)=>{
  const { patient_info } = record || {}
 
  if(patient_info?.unique_patient_id) {
    return patient_info?.unique_patient_id
  } else {
    return "_"

  }
}

export const UrgencyHandle= (text, record)=>{
  if(text){
    return <Tag color='orange'>Urgent</Tag>
  }else{
    return <Tag color='blue'>Routine</Tag>
  }
}

export const phoneNumberHandle= (text, record)=>{
  if(text){
    return text
  }else{
    return "_"

  }
}


export const upcomingDateHandle= (text, record, currentPatient)=>{
  if(text){
    if (currentPatient === record.patient_id) {
      return text.map((item)=>{
        return <div>{moment(timeStamp(item?.appointment_date_time)).format("DD/MM/YYYY hh:mm")}</div>
      })
    }
    return <div>{moment(timeStamp(text[0]?.appointment_date_time)).format("DD/MM/YYYY hh:mm")}{text?.length > 1 ? `, and ${text?.length - 1} more` : ""}</div>
  }
  return "_"
}
export const createAtDateHandle= (text, record)=>{
  if(text){
    return text
  }else{
    return "_"

  }
}

export const dateTimeFixes= (text, record)=>{
  if(moment(text).format("LT") === "Invalid date"){
    return text
  } else {
    return moment(text).format("LT")
  }
}



export const timeStampAge= (text, record)=>{
  let date = new Date(text * 1000);
  let currentDate = moment();
  let dateOfBirth = moment(date, 'DD/MM/YYYY');
  let diff = currentDate.diff(dateOfBirth, 'years');
  return diff;
}

export const patientFullName = (text, record)=>{
  if(!text){
    return record?.first_name + " " + record?.middle_name +  " " + record?.last_name
  }else{
    return text
  }
}

export const uniqueArrayById = (array) => {
  const ids = new Set();
  return array.filter(item => {
    if (!ids.has(item.id)) {
      ids.add(item.id);
      return true;
    }
    return false;
  });
};